import React, { useState } from "react";
import SideBarNavigation from "@/Components/SideBarNavigation";
import NavigationHeader from "@/Components/NavigationHeader";
import Notification from "@/Components/Notification";
import AppHead from "@/Components/AppHead";

const Authenticated = ({ title, children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div>
            <AppHead title={title} />
            <SideBarNavigation
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div className={"flex flex-1 flex-col md:pl-64"}>
                <NavigationHeader setSidebarOpen={setSidebarOpen} />
                <main className="">{children}</main>
            </div>
            <Notification />
        </div>
    );
};

export default Authenticated;
